import type { StatusTone } from "@/components/ui";
import type { DataClassification, RecordStatus } from "./types";

export function formatLabel(value: string): string {
  return value.replaceAll("_", " ");
}

export function recordStatusTone(status: RecordStatus): StatusTone {
  switch (status) {
    case "draft":
      return "info";
    case "active":
      return "success";
    case "paused":
    case "restricted":
      return "warning";
    case "suspended":
      return "danger";
    case "archived":
    case "closed":
    case "retired":
      return "neutral";
    default:
      return "neutral";
  }
}

export function classificationTone(
  classification: DataClassification,
): StatusTone {
  switch (classification) {
    case "public":
    case "internal":
      return "neutral";
    case "confidential":
      return "warning";
    case "strictly_confidential":
    case "regulated":
      return "danger";
    default:
      return "neutral";
  }
}

/**
 * Map saved_view.module string to an existing HQ route when known.
 * Unknown modules get null — no invented destinations.
 */
export function moduleDrilldownPath(module: string): string | null {
  const key = module.trim().toLowerCase().replaceAll(" ", "_");
  const map: Record<string, string> = {
    users: "/app/users",
    user: "/app/users",
    creators: "/app/creators",
    creator: "/app/creators",
    creator_center: "/app/creators",
    businesses: "/app/businesses",
    business: "/app/businesses",
    business_center: "/app/businesses",
    communities: "/app/communities",
    community: "/app/communities",
    bookings: "/app/bookings",
    booking: "/app/bookings",
    trust_and_safety: "/app/trust-safety",
    trust_safety: "/app/trust-safety",
    "trust-safety": "/app/trust-safety",
    support: "/app/support",
    finance: "/app/finance",
    marketing: "/app/marketing",
    notifications: "/app/marketing",
    marketplace: "/app/marketplace",
    marketplace_health: "/app/marketplace",
    analytics: "/app/analytics",
  };
  return map[key] ?? null;
}
